import './register.scss';
import React, { useEffect, useState } from 'react';
import { useInput }              from '../../../components/custom-hooks/input-hook';
import { useHistory, useLocation } from 'react-router-dom';
import { register }              from '../../../shared/services/user/user-service';
import { persianNumberToLatin, setLocalStorage } from '../../../shared/services/general/general-service';
import { variable_names } from '../../../shared/services/general/configs';
import Button                    from '@material-ui/core/Button';
import defaultLogo from '../../../assets/images/bebin-logo.svg';
import { useConfigApp } from '../../../shared/services/general/app-context';

export function LoginForm ({ onClose, isModal, openVerifyDialog }) {
	const savedPhoneNumber = sessionStorage.getItem('myPhoneNumber');
	const { value: principal, bind: bindPrincipal } = useInput(savedPhoneNumber ? savedPhoneNumber : '');
	const history                                   = useHistory();
	const [error, setError] = useState('');
	const location = useLocation();
	const path = location.pathname;
	useEffect(() => {
		sessionStorage.removeItem('myPhoneNumber');
	},[path])

	const validateInput = () => {
		const phoneNumberRegex = /^09\d{9}$/;
		const trimmedValue = principal.trim();

		if (trimmedValue.length < 11 && !phoneNumberRegex.test(trimmedValue)) {
			setError('لطفاً شماره همراه معتبر وارد کنید.');
		} else {
			setError('');
		}
	};

	const handleInputChange = (e) => {
		let input = e.target.value;
		input = persianNumberToLatin(input);

		if (/^\d*$/.test(input)) {
			bindPrincipal.onChange({ target: { value: input } });
		}
	};

	const handleSubmit = (evt) => {
		evt.preventDefault();
		register(principal).then(
			(result) => {
				let response = result.data;
				if (result.status === 200 && response.code === 200) {
					let token = response.data[ 'token' ];
					setLocalStorage(variable_names.principal, principal);
					sessionStorage.removeItem('myPhoneNumber');
					if (token === '') {
						if (isModal) {
							onClose();
							openVerifyDialog(true);

						} else {
							history.push('/authenticate');
						}
					} else {
						setLocalStorage(variable_names.token, token, true);
						if (isModal) {
							onClose();
							openVerifyDialog(true);
						} else {
							history.push('/verify');
						}
					}
				}
			}
		).catch(
			(error) => {
				let response = error.response.data;
				setError(response.message);
			}
		);
	};

	const isSubmitDisabled = principal.trim() === '' || error !== '';

	return (
		<>
				<h1>ورود</h1>
				<p className="text-center" style={{color: '#ffffff'}}>شماره تلفن همراه خود را وارد کنید</p>
				<form autoComplete="off"
					  dir="rtl"
					  onSubmit={handleSubmit}>
					<input {...bindPrincipal}
						   onBlur={validateInput}
						   onChange={handleInputChange}
						   type="tel"
						   maxLength="11"
						   placeholder="شماره همراه"/>
					{error && <p style={{ color: '#f95858', fontSize: '11px', margin: '0', height: '0' }}>{error}</p>}
					<Button variant={'contained'}
							type={'submit'}
							color={'default'}
							disabled={isSubmitDisabled}
					>
						<span>ورود/ثبت نام</span>
					</Button>
				</form>
		</>
	);
}

export default function RegisterContent ({ onClose, isModal = false,  openVerifyDialog }) {
	const configApp = useConfigApp();
	const [logo, setLogo] = useState([]);

	useEffect(() => {
		if (configApp) {
			const imgLogo = configApp.logo ? require(`../../../assets/images/${configApp.logo}`).default : defaultLogo;
			setLogo(imgLogo)
		}
	}, [configApp]);

	const handleOutsideClick = () => {
		onClose();
	};

	const handleInsideClick = (e) => {
		e.stopPropagation();
	};

	return (
		<>
			<div className="top-header">
				<img src={logo} alt="" />
				<strong>ورود</strong>
			</div>
			<div className="login-form" onClick={handleOutsideClick}>
				<div className="login-form-content" onClick={handleInsideClick}>
					<LoginForm
						onClose={onClose}
						openVerifyDialog={openVerifyDialog}
						isModal={isModal}
					/>
				</div>
			</div>
		</>
	);
}
